import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';

export default function MainPage() {
  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center">
      <div className="container py-5">
        <div className="d-flex flex-column align-items-center text-center">
        <h1 className="display-1 text-uppercase mb-4 row-gap-3 d-flex flex-wrap justify-content-center main-title">
          <div className="fw-bold">Printer</div>
          <div className='ani-color'>3D</div>
          <div className="fw-bold">Materials</div>
        </h1>

        <Link to="/form" className="btn btn-primary btn-mid mb-2 fw-bold ">Start</Link>

        <Link to="/list" className="btn btn-outline-primary btn-sm fw-bold">Lista materiałów</Link>
        </div>
      </div>
    </div>
  );
}
